module.exports = __webpack_public_path__ + "static/media/man-shooting.b1665261.png";